
    import './styles.scoped.css';
    export default {
  "notifications": "awsui_notifications_1hmm4_v7pka_9",
  "notifications-sticky": "awsui_notifications-sticky_1hmm4_v7pka_10",
  "no-content-paddings": "awsui_no-content-paddings_1hmm4_v7pka_25"
};
  